/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The BreadCrumbs actions
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.2.0
 */

import { createAction } from '../app/createAction';
import { BREADCRUMBS_ADD, BREADCRUMBS_CLEAR, BREADCRUMBS_GO_BACK } from './breadCrumbsConstants';
import { IAddBreadCrumbs, IBreadCrumb, IClearBreadCrumbs, TBreadCrumbsGoBack } from './breadCrumbsTypes';

export const addBreadCrumbs = (payload: IBreadCrumb[]): IAddBreadCrumbs =>
    createAction(BREADCRUMBS_ADD, payload);

export const clearBreadCrumbs = (): IClearBreadCrumbs =>
    createAction(BREADCRUMBS_CLEAR);

export const breadCrumbsGoBackAction = (): TBreadCrumbsGoBack =>
    createAction(BREADCRUMBS_GO_BACK);

export type IBreadCrumbsActionTypes = IAddBreadCrumbs
    | IClearBreadCrumbs
    | TBreadCrumbsGoBack
    ;
